import * as React from 'react';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

interface ITobaccoAlertProps {
    messageId: string;
    id: string;
    textReplacements?: { [key: string]: any };
}

const TobaccoAlert: FunctionComponent<ITobaccoAlertProps> = ({ messageId, id, textReplacements }) => {
    return (
        <>
            <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__info">
                <div className="gi-alert__body">
                    <p className="gi-alert__text">
                        <span id={id} data-testid={id} data-automation-id={id} className="gi-text">
                            <FormattedMessage id={messageId} values={{ ...textReplacements }} />
                        </span>
                    </p>
                </div>
            </div>
        </>
    );
};
export default TobaccoAlert;
